import { CommunicationActivityStatusBadge } from "./CommunicationActivityStatusBadge";

// Kept with the page rather than in the registry, so src/page/config names no app
// component. The contact record definition hands these to the registry.
export const contactFieldComponents = {
  communicationActivityStatus: CommunicationActivityStatusBadge,
};
